import { isStatusCheckReason, useSignUpAttribution } from '../useSignUpAttribution/useSignUpAttribution'

export const useIsStatusCheckSignUp = (): boolean => {
  const { signUpAttribution } = useSignUpAttribution()
  return isStatusCheckReason(signUpAttribution?.reason)
}
